const DashboardTimeSelector = {
  WEEK: 'weeks',
  MONTH: 'months',
  YEAR: 'years',
  ALL: 'all',
} as const;
export type DashboardTimeSelectorE = typeof DashboardTimeSelector[keyof typeof DashboardTimeSelector];

export default DashboardTimeSelector;
